<template>
  <div>
    <div>
      <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleCreate()">添加</el-button>
      <el-button type="primary" size="mini" icon="el-icon-download" @click="exportXl()">导出</el-button>

      <el-input
        v-model="listQueryJL.name"
        size="mini"
        clearable
        placeholder="请输入名称"
        style="width:150px;margin-left:16px"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:16px"
        @click="getJLList()"
        size="mini"
      >搜索</el-button>

      <el-button type="primary" size="mini" @click="handleJLUpdate()">编辑</el-button>
      <el-button
        type="danger"
        style="margin-left:16px"
        size="mini"
        @click="handleDelete()"
        icon="el-icon-delete"
      >删除</el-button>
    </div>

    <div style="margin-top:20px">
      <el-table
        ref="JLTable"
        :key="tableKey"
        :data="JLlist"
        height="530px"
        border
        style="width:100%"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="40" :selectable="checkboxSelect"></el-table-column>
        <el-table-column min-width="100px" align="center" :label="'培训班名称'" prop="title" show-overflow-tooltip></el-table-column>

<!--        <el-table-column width="80px" align="center" :label="'培训方式'" prop="createtype">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.createtype==1">线下</span>-->
<!--            <span v-else-if="scope.row.createtype==2">线上</span>-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column width="100px" align="center" :label="'培训类别'" prop="catedicname" show-overflow-tooltip></el-table-column>

        <el-table-column min-width="100px" align="center" :label="'培训基地'" prop="address" show-overflow-tooltip></el-table-column>

        <el-table-column min-width="100px" align="center" :label="'主办单位'" prop="deptname" show-overflow-tooltip></el-table-column>

        <el-table-column width="100px" :label="'开始时间'" align="center" prop="startime"></el-table-column>
        <el-table-column width="100px" :label="'结束时间'" align="center" prop="endtime"></el-table-column>

        <el-table-column width="80px" :label="'培训结果'" align="center" prop="state"></el-table-column>

        <el-table-column width="70px" min-height="140px" :label="'来源'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.comefrom==0">系统</span>
            <span v-else-if="scope.row.comefrom==1">用户</span>
          </template>
        </el-table-column>

        <el-table-column
            align="center"
            :label="'操作'"
            width="110"
            class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.comefrom==0" @click.prevent="toPrinting(scope.row)" plain size="mini">训历档案</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQueryJL.page"
        :limit.sync="listQueryJL.limit"
        @pagination="handleCurrentChange"
      />
    </div>

    <el-dialog title="添加" :visible.sync="dialogFormJL" width="40%">
      <el-form
        :model="JLform"
        :rules="JLrules"
        ref="JLform"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="培训班名称" prop="title">
          <el-input v-model="JLform.title"></el-input>
        </el-form-item>

        <el-form-item label="主办单位" prop="deptName">
          <el-input v-model="JLform.deptName"></el-input>
        </el-form-item>

        <el-form-item label="培训地址" prop="address">
          <el-input v-model="JLform.address"></el-input>
        </el-form-item>

        <el-form-item label="培训方式" prop="createType">
          <el-select v-model="JLform.createType" clearable placeholder="请选择">
            <el-option label="线下" :value="1"></el-option>
            <el-option label="线上" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="培训班类型" prop="cateDicId">
          <elSelectc
            :NamespaceId="53"
            :key="sid"
            :typeids="JLform.cateDicId"
            @selectData="selectDatajzDicId"
          ></elSelectc>
        </el-form-item>

        <el-form-item size="small" :label="'开始时间'" prop="starTime">
          <el-date-picker
            v-model="JLform.starTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item size="small" :label="'结束时间'" prop="endTime">
          <el-date-picker
            v-model="JLform.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="文件">
          <div style="display: flex;">
            <el-upload
              v-if="dialogFormJL"
              ref="myupload"
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="JLform.fileUrl"
              accept="application/pdf"
              :limit="1"
              :show-file-list="false"
            >
              <el-button type="primary " size="mini">上传</el-button>
            </el-upload>
            <el-button
              v-if="JLform.fileUrl"
              style="margin-left: 10px;"
              @click="activityFileHandleLook"
              size="mini"
            >查看</el-button>
            <el-button v-if="JLform.fileUrl" @click="activityFileHandleRemove" size="mini">移除</el-button>
          </div>
        </el-form-item>

        <div style="text-align:right">
          <el-button size="small" @click="dialogFormJL = false">取消</el-button>
          <el-button size="small" type="primary" @click="JLsubmit">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
import Pagination from '@/components/Pagination';
import elSelectc from '@/components/elSelect';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    Pagination,
    elSelectc,
  },
  props: {
    userId: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      dialogFormJL: false,
      tableKey: 0,
      total: 0,
      JLlist: [],
      JLform: {
        id: 0,
        title: '',
        descript: '',
        deptName: '',
        starTime: '',
        endTime: '',
        createType: null,
        cateDicId: null,
        userId: 0,
        fileUrl: '',
        passStatus: 0,
      },
      JLrules: {
        title: [
          { required: true, message: '培训班名称不能为空', trigger: 'blur' },
        ],
        deptName: [
          { required: true, message: '培训单位不能为空', trigger: 'blur' },
        ],
        starTime: [
          { required: true, message: '时间不能为空', trigger: 'blur' },
        ],
        descript: [
          { required: true, message: '培训信息不能为空', trigger: 'blur' },
        ],
        createType: [
          { required: true, message: '培训方式不能为空', trigger: 'blur' },
        ],
        cateDicId: [
          { required: true, message: '培训类型不能为空', trigger: 'blur' },
        ],
      },
      listQueryJL: {
        page: 1,
        limit: 10,
        userId: this.userId,
        name: '',
      },
      multipleSelection: [],
      sid: +new Date(),
      socreName: '',
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
    getinfo() {
      return this.$store.state.User.infos;
    },     
  },

  created() {
    let list = JSON.parse(getInfo('infos'));
    this.socreName=list.name
    this.getJLList();
  },
  methods: {
    //去打印页面
    toPrinting(item){
      window.open('/userArchives?trainId=' + item.id + '&userId=' + this.$store.state.User.ids);
    },
    checkboxSelect(row, rowIndex) {
      if (row.comefrom == 0) {
        return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectDatajzDicId(val) {
      this.JLform.cateDicId = val.value;
    },
    handleCreate() {
      this.JLform = {
        id: 0,
        title: '',
        descript: '',
        deptName: '',
        starTime: '',
        endTime: '',
        createType: null,
        cateDicId: null,
        userId: 0,
        fileUrl: '',
        passStatus: 0,
      };

      this.dialogFormJL = true;
    },
    activityFileHandleRemove(file, fileList) {
      this.JLform.fileUrl = '';
      this.$nextTick(() => {
        this.$refs.myupload.clearFiles();
      });
    },
    activitysuccess(response, file, fileList) {
      this.JLform.fileUrl = response.result;
      this.$message.success('上传成功！');
    },
    activityFileHandleLook() {
      if (this.JLform.fileUrl == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.JLform.fileUrl);
      }
    },
    JLsubmit() {
      this.$refs['JLform'].validate((vaild) => {
        if (vaild) {
          if (this.JLform.id == 0) {
            this.JLform.userId = this.userId;
            teacherInfo.TrainSelfAdd(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          } else {
            this.JLform.userId = this.userId;
            this.JLform.updateId = JSON.parse(getInfo('infos')).id;
            teacherInfo.TrainSelfUpdate(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          }
        }
      });
    },
    exportXl() {
      let that = this;
      let data = {
        page: 1,
        limit: 1000,
        userId: this.userId,
      };
      teacherInfo.getMyTrainOver(data).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].startime = element.startime.slice(0, 10);
          res.data[index].endtime = element.endtime.slice(0, 10);
        });
        let list = res.data;
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
          const tHeader = [
            '培训班名称',
            '培训方式',
            '培训类别',
            '培训基地',
            '主办单位',
            '开始时间',
            '结束时间',
            '培训结果',
            '数据来源',
          ]; // 导出的表头名信息
          const filterVal = [
            'title',
            'createtype',
            'catedicname',
            'address',
            'deptname',
            'startime',
            'endtime',
            'state',
            'comefrom',
          ]; // 导出的表头字段名，需要导出表格字段名

          list.forEach((e) => {
            if (e.createtype === 1) {
              e.createtype = '线下';
            } else {
              e.createtype = '线下';
            }

            if (e.comefrom === 0) {
              e.comefrom = '系统';
            } else {
              e.comefrom = '用户';
            }
          });

          const data = that.formatJson(filterVal, list);

          export_json_to_excel(tHeader, data, this.socreName + '训历excel'); // 导出的表格名称，根据需要自己命名
        });
      });
    },
    //格式转换，直接复制即可
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getJLList() {
      this.listQueryJL.userId = this.userId;
      teacherInfo.getMyTrainOver(this.listQueryJL).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].startime = element.startime.slice(0, 10);
          res.data[index].endtime = element.endtime.slice(0, 10);
        });
        this.JLlist = res.data;
        // console.log(this.JLlist);
        this.total = res.count;
      });
    },
    handleJLUpdate() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }
      if (this.multipleSelection.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一条=条数据进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }

      teacherInfo
        .TrainSelfGet({ id: this.multipleSelection[0].id })
        .then((res) => {
          // this.JLform = res.result;
          this.JLform = Object.assign({}, res.result);
          this.dialogFormJL = true;
          // console.log(this.JLform);
        });
    },
    handleDelete() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行删除',
          type: 'warning',
          duration: 2000,
        });
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          teacherInfo
            .TrainSelfDelete(this.multipleSelection.map((u) => u.id))
            .then((res) => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000,
              });
              this.getJLList();
            });
        });
      }
    },
    handleCurrentChange(val) {
      this.listQueryJL.page = val.page;
      this.listQueryJL.limit = val.limit;
      this.getJLList();
    },
  },
};
</script>